import React, { createContext, useState, useEffect, useContext } from "react";

const LocalIPContext = createContext();

export const LocalIPProvider = ({ children }) => {
	const [localIP, setLocalIP] = useState("Fetching...");

	useEffect(() => {
		const fetchLocalIP = async () => {
			const peerConnection = new RTCPeerConnection();

			peerConnection.createDataChannel("test");
			peerConnection.onicecandidate = (event) => {
				if (event?.candidate?.candidate) {
					const ipMatch = event.candidate.candidate.match(/([0-9]{1,3}\.){3}[0-9]{1,3}/);
					if (ipMatch) {
						setLocalIP(ipMatch[0]);
						peerConnection.close();
					}
				}
			};

			try {
				const offer = await peerConnection.createOffer();
				await peerConnection.setLocalDescription(offer);
			} catch (error) {
				console.error("Error fetching IP:", error);
			}
		};

		fetchLocalIP();
	}, []);

	return <LocalIPContext.Provider value={localIP}>{children}</LocalIPContext.Provider>;
};

export const useLocalIP = () => {
	return useContext(LocalIPContext);
};
